import { AwsRum, AwsRumConfig } from "aws-rum-web";

interface RumConfig {
  sampleRate: number;
  arn: string;
  identityPool: string;
  applicationId: string;
  applicationVersion: string;
  awsRegion: string;
}

// eslint-disable-next-line import/no-mutable-exports
let awsRum: AwsRum;

(function getRum(): void {
  try {
    if (process.env.REACT_APP_RUM_CONFIG === undefined) {
      console.error("RUM Config not found");
      throw Error("RUM Config Env var not found");
    }

    const rumConfig: RumConfig = JSON.parse(process.env.REACT_APP_RUM_CONFIG);

    const version = process.env.REACT_APP_VERSION || "0.1.0";

    const config: AwsRumConfig = {
      sessionSampleRate: rumConfig.sampleRate,
      guestRoleArn: rumConfig.arn,
      identityPoolId: rumConfig.identityPool,
      endpoint: "https://dataplane.rum.us-west-2.amazonaws.com",
      telemetries: ["performance", "errors", "http"],
      allowCookies: true,
      enableXRay: true,
    };

    const APPLICATION_ID: string = rumConfig.applicationId;
    const APPLICATION_VERSION: string = version;
    const APPLICATION_REGION: string = rumConfig.awsRegion;

    awsRum = new AwsRum(
      APPLICATION_ID,
      APPLICATION_VERSION,
      APPLICATION_REGION,
      config
    );

    console.info("rum load success");
  } catch (error) {
    // Ignore errors thrown during CloudWatch RUM web client initialization
    console.error("RUM Initilization Failure", error);
  }
})();

export { awsRum }; // export awsRum as a named export if needed
